/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocks_Hero_SubtitleInputs */

const en_stocks_hero_subtitle = /** @type {(inputs: Stocks_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Own a piece of the companies shaping the future.`)
};

const de_stocks_hero_subtitle = /** @type {(inputs: Stocks_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beteiligen Sie sich an den Unternehmen, die die Zukunft gestalten.`)
};

const pt_br2_stocks_hero_subtitle = /** @type {(inputs: Stocks_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenha uma parte das empresas que estão moldando o futuro.`)
};

const tr_stocks_hero_subtitle = /** @type {(inputs: Stocks_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geleceği şekillendiren şirketlere ortak olun.`)
};

const zh_cn2_stocks_hero_subtitle = /** @type {(inputs: Stocks_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`持有塑造未来的公司的一份股权。`)
};

const zh_hk2_stocks_hero_subtitle = /** @type {(inputs: Stocks_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`持有塑造未來的企業股份。`)
};

const ko_kr2_stocks_hero_subtitle = /** @type {(inputs: Stocks_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미래를 만들어 갈 기업의 지분을 보유하세요.`)
};

const ru_ru2_stocks_hero_subtitle = /** @type {(inputs: Stocks_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Владейте частью компаний, которые формируют будущее.`)
};

const es_419_stocks_hero_subtitle = /** @type {(inputs: Stocks_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sé dueño de una parte de las empresas que están construyendo el futuro.`)
};

/**
* | output |
* | --- |
* | "Own a piece of the companies shaping the future." |
*
* @param {Stocks_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const stocks_hero_subtitle = /** @type {((inputs?: Stocks_Hero_SubtitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocks_Hero_SubtitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stocks_hero_subtitle(inputs)
	if (locale === "de") return de_stocks_hero_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_stocks_hero_subtitle(inputs)
	if (locale === "tr") return tr_stocks_hero_subtitle(inputs)
	if (locale === "zh-CN") return zh_cn2_stocks_hero_subtitle(inputs)
	if (locale === "zh-HK") return zh_hk2_stocks_hero_subtitle(inputs)
	if (locale === "ko-KR") return ko_kr2_stocks_hero_subtitle(inputs)
	if (locale === "ru-RU") return ru_ru2_stocks_hero_subtitle(inputs)
	return es_419_stocks_hero_subtitle(inputs)
});